import type { TipoItem } from '../api'
import { leerNumero } from '../formato'

export type TipoEquipo = Exclude<TipoItem, 'otro'>

/** Lo que pide cada tipo para poder calcular con él, y en qué unidad se escribe. */
export const DATO_TECNICO: Record<TipoEquipo, { tipo: string; etiqueta: string; ejemplo: string }> = {
  panel: { tipo: 'Panel', etiqueta: 'Potencia del panel (W)', ejemplo: 'Ej.: 585' },
  inversor: { tipo: 'Inversor', etiqueta: 'Potencia del inversor (kW)', ejemplo: 'Ej.: 8' },
  bateria: { tipo: 'Batería', etiqueta: 'Capacidad de la batería (kWh)', ejemplo: 'Ej.: 10' },
}

/**
 * Lo escrito -> lo que se manda al servidor. El inversor se escribe en kW y viaja en W, como el
 * panel; la batería va en kWh. Devuelve un texto si no vale (es lo que se le muestra al admin).
 */
export function leerDatoTecnico(tipo: TipoEquipo, texto: string): { potencia_w: number | null; capacidad_kwh: number | null } | string {
  const n = leerNumero(texto)
  if (n === null || Number.isNaN(n) || n <= 0) return `Escribe la ${DATO_TECNICO[tipo].etiqueta.toLowerCase()}, un número mayor que cero.`
  if (tipo === 'bateria') return { potencia_w: null, capacidad_kwh: n }
  return { potencia_w: tipo === 'inversor' ? Math.round(n * 1000) : Math.round(n), capacidad_kwh: null }
}
